import React, { useState, useEffect } from "react";
import { HiOutlineRefresh } from "react-icons/hi";
import { Col, Row } from "react-bootstrap";
import styled from "styled-components";
import { useForm } from "react-hook-form";

import { ActivationPageWrapper } from "./activationPage.styled";

import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  createNewEAdminReq,
  get_eAdminListReq,
} from "../../api/eAdmin/eAdminReq";
import { SagaActions } from "../../redux/actionTypes";
import { getCEPsListReq } from "../../api/cep/cepAdminRequest";
import RenderIf from "../../components/renderIf";
import TextInputLayout from "../../components/compLayouts/textInputLayout";
import { validate } from "../../constants/validationExp";
import MobileNoLayout from "../../components/compLayouts/mobileNoLayout";
import RecentAdminTable from "./components/recentAdminTable";
import dayjs from "dayjs";
import { getPlansListReq } from "../../api/activation/plansReq";
import { RootState } from "../../redux/store";
import { COUNTRY_CODES } from "../../constants/countryCodes";

type Inputs = {
  companyNameIs: string;
  countryCodeIs: string;
  mobileNumberIs: string;
  emailIs: string;
  nameIs: string;
  firstName: string;
  lastName: string;
  designationIs: string;
  CEPPartnerIs: number;
  plans: string;
  planValidity: string;
};

type cepPatnerList = {
  user: { userID: number };
  employee: { firstName: string; lastName: string };
};

type plansList = {
  subscriptionID: number;
  subscriptionName: string;
};

export const ActivationPage = () => {
  const Dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm<Inputs>();
  const phNo = watch("mobileNumberIs");
  const _numberError = errors.mobileNumberIs?.message;
  const { plans } = useSelector((_state: RootState) => _state);

  const _planList = plans?.data || [];
  const [plansList, setplansList] = useState<plansList[]>();
  const [recentInvitedEAdmins, setrecentInvitedEAdmins] = useState([]);
  const [cepPatnerList, setcepPatnerList] = useState<cepPatnerList[]>([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState<string>("+91");
  const [selectedTimeZone, setSelectedTimeZone] = useState<string>("India (GMT+5:30)");
  const [isLoading, setIsLoading] = useState(false);

  const handleCountryCodeChange = (e: any) => {
    const selectedCountryCode = e.countryCode;
    const selectedCountry = COUNTRY_CODES.find(
      (country) => country.countryCode === selectedCountryCode
    );
    if (selectedCountry) {
      setSelectedCountryCode(selectedCountry.countryCode);
      setSelectedTimeZone(selectedCountry.countryTimeZone[0].zone);
    }
  };

  const handleTimeZoneChange = (e: any) => {
    setSelectedTimeZone(e.target.value);
  };

  const createEAdminfun = async (data: Inputs) => {
    if (isLoading) return; // Prevent duplicate submissions

    setIsLoading(true);
    try {
      const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        const month = date.toLocaleString("en-US", { month: "short" });
        const day = date.getDate();
        const year = date.getFullYear();
        return `${month} ${day} ${year}`;
      };
      const _data = {
        PhoneCountryCode: Number(selectedCountryCode.replace("+", "")),
        TimeZone: selectedTimeZone,
        CompanyName: data?.companyNameIs,
        mobileNumber: data?.mobileNumberIs,
        email: data?.emailIs,
        subscriptionID: data?.plans,
        subscriptionValidUpto: formatDate(data?.planValidity),
        firstName: data?.firstName,
        lastName: data?.lastName,
        designation: data?.designationIs,
        CEPPartnerID: Number(data?.CEPPartnerIs),
      };
      console.log(_data, "_data of createEAdminfun");

      toast.info("Creating E-Admin profile... Please wait.", { autoClose: 2000 });
      const res = await createNewEAdminReq(_data);
      toast.success(res?.message || "E-Admin created successfully!", {
        autoClose: 4000,
        position: "top-right",
      });
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "prod",
          message: res?.message,
          fileName: "activationPage",
          methodName: "createEAdminfun",
          type: "info",
        },
      });
      reset();
      fetchCEPlistfun();
    } catch (error: any) {
      const errorMessage = error?.errorMsg || "Failed to create E-Admin. Please check the form data and try again.";
      toast.error(errorMessage, {
        autoClose: 5000,
        position: "top-right",
      });
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "prod",
          message: error?.errorMsg,
          fileName: "activationPage",
          methodName: "createEAdminfun",
          type: "error",
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCEPlistfun = async () => {
    try {
      const res = await get_eAdminListReq();
      setrecentInvitedEAdmins(res?.data || []);
    } catch (error: any) {
      console.error('Error fetching E-Admin list:', error?.errorMsg);
    }
  };

  // const getSubscriberPlansFun = async () => {
  //   try {
  //     const res = await getPlansListReq();
  //     setplansList(res.data);
  //     Dispatch({
  //       type: SagaActions.INFO,
  //       payload: {
  //         env: "dev",
  //         message: res?.message,
  //         fileName: "plan",
  //         methodName: "getSubscriberPlansFun",
  //         type: "info",
  //       },
  //     });
  //   } catch (error: any) {
  //     Dispatch({
  //       type: SagaActions.ERROR,
  //       payload: {
  //         env: "prod",
  //         message: error?.errorMsg,
  //         fileName: "plan",
  //         methodName: "getSubscriberPlansFun",
  //         type: "error",
  //       },
  //     });
  //   }
  // };

  const fetchCEP_PatnerList = async () => {
    try {
      const res = await getCEPsListReq();
      setcepPatnerList(res?.data || []);
    } catch (error: any) {
      console.error('Error fetching CEP partner list:', error?.errorMsg);
    }
  };

  const handleButtonClick = ({ key, data }: { key: string; data?: any }) => {
    const btnFun: any = {
      createCep: (data: Inputs) => createEAdminfun(data),
    };
    btnFun[key](data);
  };

  useEffect(() => {
    fetchCEPlistfun();
    fetchCEP_PatnerList();
  }, []);

  useEffect(() => {
    Dispatch({ type: SagaActions.GET_PLANS });
  }, []);

  return (
    <ActivationPageWrapper className="p-2 h-100">
      <div className="">
        <div className="p-2 mx-2">
          <form
            className="w-100 p-2"
            onSubmit={handleSubmit((data) => {
              handleButtonClick({ key: "createCep", data });
            })}
          >
            <p className="my-1 lg-text">
              <strong>Onboard A New E-Admin:</strong>
            </p>
            <div className="p-2"></div>
            <div className="mx-1 bg-white py-3 p-2 rounded shadow-block row">
              <div className="col-lg-3 col-md-6">
                <TextInputLayout
                  isError={errors.firstName?.message}
                  label={"First Name"}
                  required
                >
                  <input
                    className={`flex-grow-1`}
                    autoComplete="off"
                    {...register("firstName", {
                      required: " Please enter First Name",
                    })}
                  />
                </TextInputLayout>
              </div>
              <div className="col-lg-3 col-md-6">
                <TextInputLayout
                  isError={errors.lastName?.message}
                  label={"Last Name"}
                >
                  <input
                    className={`flex-grow-1`}
                    autoComplete="off"
                    {...register("lastName")}
                  />
                </TextInputLayout>
              </div>
              <div className="col-lg-3 col-md-6">
                <TextInputLayout
                  isError={errors.companyNameIs?.message}
                  label={"Company name"}
                  required
                >
                  <input
                    className={`flex-grow-1`}
                    autoComplete="off"
                    {...register("companyNameIs", {
                      required: " Please enter Company name",
                    })}
                  />
                </TextInputLayout>
              </div>
              <div className="col-lg-3 col-md-6">
                <TextInputLayout
                  isError={errors.designationIs?.message}
                  label={"Designation"}
                  required
                >
                  <input
                    className={`flex-grow-1`}
                    autoComplete="off"
                    {...register("designationIs", {
                      required: " Please enter Designation",
                    })}
                  />
                </TextInputLayout>
              </div>
              <div className="col-lg-4 col-md-6">
                <TextInputLayout
                  isError={errors.emailIs?.message}
                  label={"Email"}
                  required
                >
                  <input
                    className={`flex-grow-1`}
                    autoComplete="off"
                    {...register("emailIs", {
                      required: "Please enter Email",
                      pattern: {
                        value: validate.email,
                        message: "Entered incorrect email format",
                      },
                    })}
                  />
                </TextInputLayout>
              </div>
              <div className="col-lg-4 col-md-6">
                <MobileNoLayout
                  isError={_numberError}
                  mobileNumber={phNo}
                  required
                  onCountryCodeChange={handleCountryCodeChange}
                  // countryCodeOptions={COUNTRY_CODES}
                  selectedCountryCode={selectedCountryCode}
                >
                  <input
                    className={`flex-grow-1 `}
                    placeholder=""
                    type="tel"
                    maxLength={10}
                    {...register("mobileNumberIs", {
                      required: "Enter 10 digit mobile number",
                      maxLength: {
                        value: 10,
                        message: "Enter 10 digit mobile number",
                      },
                      minLength: {
                        value: 10,
                        message: "Enter 10 digit mobile number",
                      },
                      pattern: {
                        value: validate.phone,
                        message: "Incorrect mobile number",
                      },
                    })}
                  />
                </MobileNoLayout>
              </div>
              <div className="col-lg-4 col-md-6">
                <TextInputLayout
                  // isError={errors.CEPPartnerIs?.message}
                  label={"Time Zone"}
                  required
                >
                  <select
                    className="w-100  border-0 px-3 "
                    style={{ outline: "none" }}
                    // {...register("countryCodeIs", {
                    //   required: "Please select compan",
                    // })}
                    value={selectedTimeZone}
                    onChange={handleTimeZoneChange}
                  >
                    {/* <option value="">Select</option> */}
                    {selectedCountryCode &&
                      COUNTRY_CODES.find(
                        (country) => country.countryCode === selectedCountryCode
                      )?.countryTimeZone.map((timezone) => (
                        <option key={timezone.zone} value={timezone.zone}>
                          {timezone.zone}
                        </option>
                      ))}
                  </select>
                </TextInputLayout>
              </div>
              <div className="col-lg-3 col-md-6">
                <TextInputLayout
                  isError={errors.CEPPartnerIs?.message}
                  label={"CEP Partner"}
                  required
                >
                  <select
                    className="w-100  border-0"
                    style={{ outline: "none" }}
                    {...register("CEPPartnerIs", {
                      required: "Please select Email",
                    })}
                  >
                    <option value="">Select</option>
                    {cepPatnerList.map((item) => (
                      <option key={item.user.userID} value={item.user.userID}>
                        {item.employee.firstName} {item.employee.lastName}
                      </option>
                    ))}
                  </select>
                </TextInputLayout>
              </div>
              <div className="col-lg-3 col-md-6">
                <TextInputLayout
                  isError={errors.plans?.message}
                  label={"Plans"}
                  required
                >
                  <select
                    className="w-100  border-0"
                    style={{ outline: "none" }}
                    {...register("plans", {
                      required: "Please select plan",
                    })}
                  >
                    <option value="">Select</option>
                    {_planList?.map((item: any) => (
                      <option
                        key={item.subscriptionID}
                        value={item.subscriptionID}
                      >
                        {item.subscriptionName}
                      </option>
                    ))}
                  </select>
                </TextInputLayout>
              </div>
              <div className="col-lg-3 col-md-6">
                <TextInputLayout
                  isError={errors.planValidity?.message}
                  label={"Plan validity"}
                  required
                >
                  <input
                    className="w-100"
                    type="date"
                    placeholder="Select a date"
                    min={dayjs().add(1, "day").format("YYYY-MM-DD")}
                    {...register("planValidity", {
                      required: "Plan validity required",
                    })}
                  />
                </TextInputLayout>
              </div>
              <div className=" col-lg-3 col-md-4 d-flex flex-column justify-content-end p-2">
                <button
                  type="submit"
                  className="btn primary-bg text-white w-100"
                  disabled={isLoading}
                  style={{ opacity: isLoading ? 0.6 : 1 }}
                >
                  {isLoading ? "Creating..." : "Send Invite"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="w-100 p-2">
        <div className="shadow-block bg-white p-3 mx-3 m-2 rounded">
          <p className="m-1 md-text">Recently Invited E-Admins:</p>
          <div className="p-2"></div>
          <RenderIf isShow={recentInvitedEAdmins?.length > 0}>
            <RecentAdminTable tableData={recentInvitedEAdmins} />
          </RenderIf>
          <RenderIf isShow={recentInvitedEAdmins?.length < 1}>
            <div className="w-100 d-flex align-items-center justify-content-center">
              <p className="text-secondary m-3">-: No Data :-</p>
            </div>
          </RenderIf>
        </div>
      </div>
    </ActivationPageWrapper>
  );
};

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  input {
    border: none;
    outline: none;
    padding: 0px 10px;
  }
  .input_box {
    display: flex;
    align-items: center;
    border-radius: 8px;
    height: 35px;
    overflow: hidden;
    border-radius: 6px;
    border: 1px solid rgb(216, 216, 216);
  }
  .icon_box {
    height: 25px;
    width: 25px;
    border: 0px solid;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
  .image_icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border: 0px solid;
  }
  .country_code_box {
    /* width: 100px; */
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 8px;
    height: 45px;
    border: 1px solid rgb(200, 200, 200);
  }
`;
